import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = styled.button`
  ${tw`fixed p-3 rounded-full transition-opacity duration-300 z-50 flex items-center justify-center`}
  bottom: 1.5rem;
  right: 1.5rem;
  background: radial-gradient(circle at center,rgb(255, 0, 0), #1a1a1a);
  border: 1px solid #444;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
  color: #ffffff;
  font-size: 1rem;
  opacity: ${({ show }) => (show ? "1" : "0")};
  pointer-events: ${({ show }) => (show ? "auto" : "none")};
  backdrop-filter: blur(2px);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 0 12px rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
}
    animation: softPulse 2.5s ease-in-out infinite alternate;

@keyframes softPulse {
  from {
    box-shadow: 0 0 6px rgba(255, 255, 255, 0.1);
  }
  to {
    box-shadow: 0 0 12px rgba(255, 255, 255, 0.25);
  }
}

`;



const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);

  // Maneja la visibilidad del botón en función del scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Limpia el evento al desmontar el componente
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Función para desplazarse al tope de la página
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 50) {  // Baja el umbral a 50 píxeles para que aparezca antes
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
  
    // Limpia el evento cuando se desmonte el componente
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  

  return (
    <ScrollToTopButton onClick={scrollToTop} show={showButton}>
      <FaArrowUp size={20} />
    </ScrollToTopButton>
  );
};

export default ScrollToTop;
